import * as _ from 'lodash';

export enum States {
    NSW = "New South Wales",
    QLD = "Queensland",
    SA = "South Australia",
    TAS = "Tasmania",
    VIC = "Victoria",
    WA = "Western Australia",
    ACT = "Australian Capital Territory",
    NT = "Northern Territory",
    HO = "Head Office"
}

export enum DriverLicenseType {
    DL = "Drivers License",
    PDL = "Probationary Driver License",
    LRL = "Light Rigid License",
    MRL = "Medium Rigid License",
    HRL = "Heavy Rigid License",
    HC = "Heavy Combination",
    MC = "Multi Combination",
    IL = "International License"
}

export class enumLists {
    driversLicense: any[] = [];
    states: any[] = [];
    constructor () {
        _.forIn(DriverLicenseType, (value: any, key: any) => {
            this.driversLicense.push({key: key, value: value});
        });

        _.forIn(States, (value: any, key: any) => {
            this.states.push({key: key, value: value});
        });

        this.states = _.orderBy(this.states, ['value'], 'asc');
    }
}

export enum LoadingMessage {
  TimeTravel = "Time travel takes a second! Zooming through your filtered records...",
  Barista = "Compiling your requested dataset. Perfect time for a quick coffee stretch!",
  TechNerd = "Feeding your filtered parameters into the supercomputer... beep boop beep...",
  Archaeologist = "Dusting off the archives... pulling your custom data view now!",
  Chef = "Simmering a massive data stew. Stirring and filtering as fast as we can!",
  Runner = "Going the distance! Running through the records to grab your specific data.",
  Magician = "Gathering the big picture... making your dashboard data appear in 3, 2, 1...",
  Gnomes = "Sorting through a massive pile of records... almost there!",
  HypeMan = "Preparing your custom report view. Trust us, it’s worth the short wait!"
}

export const LOADING_MESSAGES_LIST: string[] = Object.values(LoadingMessage);

export function getRandomLoadingMessage(): string {
    const randomIndex = Math.floor(Math.random() * LOADING_MESSAGES_LIST.length);
    return LOADING_MESSAGES_LIST[randomIndex];
}

export enum Availability {
    ALLOCATED = 1,
    STANDBY = 2,
    UNAVAILABLE = 3
}

export const ITEMS_PER_TABLE_PAGE: number[] = [20,25,50,75];

export enum AccountTypes {
    FLEET_MANAGER = 1,
    TEST_ACCOUNT = 2
}

export enum ShipmentSource {
    ADMIN_PANEL = 1,
    MACHSHIP = 2,
    CPJOBS = 3
}

export enum USER_ROLE {
    SUPERADMIN = 1,
    ADMIN = 2,
    OPERATIONS = 3,
    COMPLIANCE_MANAGER = 4,
    ACCOUNTS = 5
}